import { cleanCommonParams } from './common';

const mapRedirectParams = (isCreate, params) => {
    return new Promise((resolve) => {
        resolve({
            redirect_record: {
                ...cleanCommonParams(params),
            },
        });
    });
};

export { mapRedirectParams };
